
import ServicePath from "@/core/ServicePath";
import { MainRequest } from "@/core/request";
import ServiceConstant from "@/app/core/ServiceConstant";


export default class StudyRequest extends MainRequest {

    static addStudy(data, token) {
        return this.postSEC(ServicePath.STUDY_ADD, data);
    }

    static listAllStudies(token) {
        return this.getSEC(ServicePath.STUDY_LIST_ALL);
    }

    static listAllStudiesHistory(data) {
        return this.postSEC(ServicePath.STUDY_LIST_HISTORY,data);
    }

    static updateStudy(data, token) {
        return this.postSEC(ServicePath.STUDY_UPDATE, data);
    }

    static deleteStudy(data, token) {
        return this.postSEC(ServicePath.STUDY_DELETE, data);
    }

    static getStudy(data) {
        return this.postSEC(ServicePath.STUDY_BY_ID, data)
    }

    static validatePACS(data) {
        return this.postSEC(ServicePath.STUDY_VALIDATE_PACS, data)
    }

    static papanicolaouForm(data) {
        return this.postSEC(ServicePath.STUDY_PAPANICOLAOU_FORM, data)
    }

    static papanicolaouTable(data) {
        return this.postSEC(ServicePath.STUDY_PAPANICOLAOU_TABLE, data)
    }

    static papanicolaouSaveForm(data) {
        return this.postSEC(ServicePath.STUDY_PAPANICOLAOU_SAVE_FORM, data)
    }

    static papanicolaouSaveTable(data) {
        return this.postSEC(ServicePath.STUDY_PAPANICOLAOU_SAVE_TABLE, data)
    }

    static papanicolaouSaveFiles(data) {
        return this.postSEC(ServicePath.STUDY_PAPANICOLAOU_SAVE_FILES, data)
    }

    static papanicolaouEditForm(data) {
        return this.postSEC(ServicePath.STUDY_PAPANICOLAOU_EDIT_FORM, data)
    }

    static papanicolaouEditTable(data) {
        return this.postSEC(ServicePath.STUDY_PAPANICOLAOU_EDIT_TABLE, data)
    }

    static papanicolaouDowloadReport(object) {
        return this.postPDFSEC(ServicePath.STUDY_PAPANICOLAOU_DOWNLOAD_REPORT, object)
          .then(response => {
            const url = URL.createObjectURL(
              new Blob([response.data], { type: 'application/pdf' })
            );
            window.open(url);
            return response;
          });
      }
    
    static papanicolaouViewReport(data) {
        return this.postSEC(ServicePath.STUDY_PAPANICOLAOU_REPORT, data)
    }

    static papanicolaouDowloadExcel(data) {
        return this.postPDFSEC(ServicePath.STUDY_PAPANICOLAOU_DOWNLOAD_EXCEL, data)
    }

    static listAllByStatus(data) {
        return this.postSEC(ServicePath.STUDY_LIST_ALL_BY_ESTATUS, data)
    }

    static beginStudy(data) {
        return this.postSEC(ServicePath.STUDY_BEGIN, data)
    }

    static closeStudy(data) {
        return this.postSEC(ServicePath.STUDY_READY, data)
    }

    static cancelStudy(data) {
        return this.postSEC(ServicePath.STUDY_CANCEL, data)
    }

    static addListStudies(data) {
        return this.postSEC(ServicePath.STUDY_ADD_LIST_STUDIES, data)
    }

    static changeStatus(data) {
        return this.postSEC(ServicePath.STUDY_CHANGE_STATUS, data)
    }

    static reportStudy(data){
        return this.postSEC(ServicePath.STUDY_CHANGE_STATUS_REPORTER, data)
    }

    static discardStudy(data){
        return this.postSEC(ServicePath.STUDY_CHANGE_STATUS_DISCARD, data)
    }

    static findAllImagesByStudy(data){
        return this.postSEC(ServicePath.STUDY_FIND_ALL_IMAGES_BY_STUDY, data)
    }

    static findURLJNLP(data){
        return this.postSEC(ServiceConstant.STUDY_FIND_URL_JNLP, data)
    }
    static listAllStudyHistory(data){
        return this.postSEC(ServicePath.STUDY_HISTORY_BRANCH_OFFICE, data)
    }
    static studyInterpretationPendingValidatePacs(data){
        return this.postSEC(ServicePath.STUDY_INTERPRETATION_PENDING_VALIDATE_PACS, data)
    }

    static revalidate(data){
        return this.postSEC(ServicePath.STUDY_REVALIDATE, data)
    }
    
    static generateLinkToShareWA(data){
        return this.postSEC(ServicePath.STUDY_LINK_TO_SHARE_WA, data)
    }

    static generateLinkToViewImages(idStudy){
        return this.postSEC(ServicePath.STUDY_LINK_TO_VIEW_IMAGES, {idStudy: idStudy});
    }

    static findAllStudiesByPatient(idPatient){
        return this.postSEC(ServicePath.STUDIES_BY_PATIENT, {idPatient: idPatient});
    }

}